import { Box, Button, Modal } from '@mui/material';
import * as React from 'react';
import { useSegment } from 'common/hooks/segment';

import styles from 'styles/typography.module.css';

import { AddForm } from './add-form';
import { TrackContainers } from './types';

interface Props {
  /** Forces the modal to be visible; note setting this to false will not close an existing modal */
  forceShow?: boolean;
  /** Container numbers to have pre-populate upon showing the modal  */
  prepopulatedContainers?: string[];
  /** Callback fired when the modal is closed; useful for clearing the prepopulatedContainers before next show */
  onClose?: () => void;
  /** Callback fired when the user presses track after entering or selecting a file to upload  */
  onTrackAndTrace: (containers: TrackContainers) => void;
}

/**
 * Renders the Add Containers button and the resulting modal when clicked
 */
export const AddContainers: React.FC<Props> = (props: Props) => {
  const { trackEventNoSlack } = useSegment();

  const { forceShow, prepopulatedContainers, onClose, onTrackAndTrace } = props;
  const [showModal, setShowModal] = React.useState(forceShow || false);

  const close = React.useCallback(() => {
    setShowModal(false);
    if (onClose) {
      onClose();
    }
  }, [setShowModal, onClose]);

  const handleOnClickAddContainers = () => {
    trackEventNoSlack('Add Containers Modal Opened');
    setShowModal((isShowing) => !isShowing);
  };

  React.useEffect(() => {
    if (forceShow) {
      setShowModal(forceShow);
    }
  }, [forceShow]);

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        className="shadow-sm"
        onClick={handleOnClickAddContainers}
      >
        <h4>+ Add Containers</h4>
      </Button>
      <Modal open={showModal} onClose={close} classes={{ root: `${styles.font} overflow-auto` }}>
        <Box
          sx={{
            width: 964,
            left: '50%',
            top: 64,
            position: 'absolute',
            transform: 'translateX(-50%)',
          }}
        >
          <AddForm
            onTrackAndTrace={(containers) => {
              if (containers) {
                onTrackAndTrace(containers);
              }
              close();
            }}
            prepopulatedContainers={prepopulatedContainers}
          />
        </Box>
      </Modal>
    </>
  );
};
AddContainers.displayName = 'TrackAndTrace.AddContainers';
